<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
  }>(),
  {},
)
</script>

<template>
  <header class="-mx-8 -mt-6 mb-8 bg-[#2a3f54] px-8 pb-0 pt-6">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <h2 class="text-2xl font-bold leading-7 text-white">
          {{ title }}
        </h2>
        <slot name="stage-pill" />
      </div>
      <div class="flex items-center gap-2">
        <slot name="actions" />
      </div>
    </div>
    <div class="mt-6">
      <slot name="tabs" />
    </div>
  </header>
</template>
